import _ from 'lodash';
import mutationTypes from './types/mutation.types';
import { stateLoader } from './state';

const mutations = {
  [mutationTypes.SET_DISPOSE](state) {
    Object.assign(state, stateLoader());
  },
  [mutationTypes.SET_ACADEMIC_YEARS](state, payload) {
    state.catalog.academicYears = payload;
  },
  [mutationTypes.SET_MONTHS](state, payload) {
    state.catalog.months = payload;
  },
  [mutationTypes.SET_CENTERS](state, payload) {
    state.catalog.centers = payload;
  },
  [mutationTypes.SET_SERVICE_TYPES](state, payload) {
    state.catalog.serviceTypes = payload;
  },
  [mutationTypes.SET_INTERVENTORS](state, payload) {
    state.catalog.interventors = payload;
  },
  [mutationTypes.SET_PROVIDERS](state, payload) {
    state.catalog.providers = payload;
  },
  [mutationTypes.SET_PROVIDERS_SERVICE_TYPE](state, payload) {
    state.catalog.providers = payload;
  },
  [mutationTypes.SET_STATUS](state, payload) {
    state.catalog.status = payload;
  },
  [mutationTypes.SET_BILLING_SEARCH_RESULT](state, payload) {
    state.billingSearchResults = {
      ...state.billingSearchResults,
      data: payload.data,
      pagination: {
        count: payload.count,
        currentPage: payload.currentPage,
        pageCount: payload.pageCount,
        totalItemCount: payload.totalItemCount,
      },
    };
  },
  [mutationTypes.SET_BILLING_FILTER](state, payload) {
    state.filter = {
      ...payload,
    };
  },
  [mutationTypes.SET_BILLING_SERVICE_DETAILS](state, payload) {
    state.billingServiceDetails = {
      data: payload.map((item) => ({
        ...item,
        details: {
          visitDetailsList: {},
          billingAdjustmentDetails: [],
        },
      })),
    };
  },
  [mutationTypes.SET_BILLING_SERVICE_DETAILS_PAGINATION](state, payload) {
    const data = state.billingServiceDetails.data[0];
    const items = Array(data != null ? data.totalRows : data);
    state.billingServiceDetails = {
      ...state.billingServiceDetails,
      pagination: {
        ...state.billingServiceDetails.pagination,
        currentPage: payload.currentPage,
        count: 15,
        pageCount: _.chunk(items != null ? items : 0, 15).length,
        totalItemCount: data != null ? data.totalRows : 0,
      },
    };
  },
  [mutationTypes.SET_BILLING_SERVICE_DETAILS_INFO](
    state,
    { itemIndex, payload }
  ) {
    state.billingServiceDetails = {
      ...state.billingServiceDetails,
      data: state.billingServiceDetails.data.map((s, index) => {
        if (itemIndex === index) {
          s.isOpen = !s.isOpen;
          s = {
            ...s,
            ...payload,
          };
        } else {
          s.isOpen = false;
        }
        return s;
      }),
    };
  },
  [mutationTypes.SET_VISIT_DETAILS](state, { payload, item }) {
    state.billingServiceDetails = {
      ...state.billingServiceDetails,
      data: state.billingServiceDetails.data.map((s, index) => {
        if (item.itemIndex === index) {
          s.details = {
            ...s.details,
            visitDetailsList: {
              data: payload.data,
              pagination: {
                count: payload.count,
                currentPage: payload.currentPage,
                pageCount: payload.pageCount,
                totalItemCount: payload.totalItemCount,
              },
            },
          };
        }
        return s;
      }),
    };
  },
  [mutationTypes.SET_BILLING_ADDITIONAL_INFO](state, { itemIndex, data }) {
    state.billingServiceDetails = {
      ...state.billingServiceDetails,
      data: state.billingServiceDetails.data.map((s, index) => {
        if (itemIndex === index) {
          s.details = {
            ...s.details,
            ...data,
          };
        }
        return s;
      }),
    };
  },
  [mutationTypes.SET_BILLING_VISIT_CERT_DOCUMENT_TYPES](
    state,
    { payload, itemIndex }
  ) {
    state.billingServiceDetails = {
      ...state.billingServiceDetails,
      data: state.billingServiceDetails.data.map((s, index) => {
        if (itemIndex === index) {
          s.certsDocumentTypes = payload;
        }
        return s;
      }),
    };
  },
  [mutationTypes.SET_BILLING_ADJUSTMENTS_DETAILS](
    state,
    { itemIndex, payload }
  ) {
    state.billingServiceDetails = {
      ...state.billingServiceDetails,
      data: state.billingServiceDetails.data.map((s, index) => {
        if (itemIndex === index) {
          s.details = {
            ...s.details,
            billingAdjustmentDetails: payload,
          };
        }
        return s;
      }),
    };
  },
  [mutationTypes.SET_BILLING_STATUS_TRANSITION](state, payload) {
    state.billingStatusList = payload;
  },
  [mutationTypes.SET_BILLING_DETAILS_SERVICE_TYPE](state, payload) {
    state.catalog = {
      ...state.catalog,
      billingServiceTypes: payload,
    };
  },
  [mutationTypes.SET_BILLING_DETAILS_DISCIPLINE](state, payload) {
    state.catalog = {
      ...state.catalog,
      billingDisciplines: payload,
    };
  },
  [mutationTypes.SET_BILLING_DETAILS_SPECIALIST](state, payload) {
    state.catalog = {
      ...state.catalog,
      billingSpecialists: payload,
    };
  },
  [mutationTypes.SET_BILLING_FILTER](state, payload) {
    state.billingServiceFilter = {
      ...state.billingServiceFilter,
      ...payload,
    };
  },
  [mutationTypes.SET_CATALOG](state, payload) {
    state.catalog = {
      ...state.catalog,
      ...payload,
    };
  },
  [mutationTypes.SET_CHECK_UNCHECK_FLAG_SERVICE_DETAIL](
    state,
    { checked, checkedAll, itemIndex }
  ) {
    state.billingServiceDetails = {
      ...state.billingServiceDetails,
      data: state.billingServiceDetails.data.map((s, index) => {
        if (checkedAll) {
          s.checkedFlag = true;
        } else {
          if (itemIndex === index) {
            s.checkedFlag = checked;
          }
        }
        return s;
      }),
    };
  },
  [mutationTypes.SET_BILLING_TRACKING](state, payload) {
    state.billingTracking = payload;
  },
  [mutationTypes.SET_BILLING_ADJUSTMENTS_DETAILS_LIST](state, payload) {
    state.billingAdjustmentDetailList = {
      data: payload.data,
      pagination: {
        count: payload.count,
        currentPage: payload.currentPage,
        pageCount: payload.pageCount,
        totalItemCount: payload.totalItemCount,
      },
    };
  },
  [mutationTypes.SET_BILLING_ADJUSTMENT_OBJECTION](state, { prop, itemIndex }) {
    state.billingAdjustmentDetailList = {
      ...state.billingAdjustmentDetailList,
      data: state.billingAdjustmentDetailList.data.map((item, index) => {
        if (itemIndex === index) {
          item = {
            ...item,
            ...prop,
          };
        } else {
          item.addNewObjection = false;
        }
        return item;
      }),
    };
  },
  [mutationTypes.SET_BILLING_SERVICE_ADJUSTMENTS](
    state,
    { itemIndex, payload }
  ) {
    state.billingServiceDetails = {
      ...state.billingServiceDetails,
      data: state.billingServiceDetails.data.map((s, index) => {
        if (itemIndex === index) {
          const chunked = _.chunk(payload, 5); //Limit for Page
          s.details = {
            ...s.details,
            billingAdjustmentDetails: {
              data: chunked[0], //First List of Adjustments (Page 1)
              resultsChunked: chunked,
              pagination: {
                currentPage: 1,
                count: 5,
                pageCount: chunked.length,
                totalItemCount: payload != null ? payload.length : 0,
              },
            },
          };
        }
        return s;
      }),
    };
  },
  [mutationTypes.SET_REASONS](state, payload) {
    state.adjustmentDetails.reasons = payload;
  },
  [mutationTypes.SET_VISITS](state, payload) {
    state.adjustmentDetails.visits = payload;
  },
  [mutationTypes.SET_SERVICE_ADJUSTMENT_PAGING](state, payload) {
    const itemIndex = payload.itemIndex;
    state.billingServiceDetails = {
      ...state.billingServiceDetails,
      data: state.billingServiceDetails.data.map((s, index) => {
        if (itemIndex === index) {
          const data = s.details.billingAdjustmentDetails.resultsChunked;
          s.details.billingAdjustmentDetails = {
            ...s.details.billingAdjustmentDetails,
            data: data[payload.currentPage - 1],
            pagination: {
              ...s.details.billingAdjustmentDetails.pagination,
              currentPage: payload.currentPage,
            },
          };
        }
        return s;
      }),
    };
  },
};

export default mutations;
